import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  marketingNewsData: [],
  marketingSources: [],
  marketingCategories: [],
};

const MarketingNewsReducer = handleActions(
  {
    GET_MARKETING_NEWS: (state, action) => {
      return {
        ...state,
        marketingNewsData: action.payload,
      };
    },
    CREATE_MARKETING_NEWS: (state, action) => {
      return {
        ...state,
        marketingNewsData: [...state.marketingNewsData, action.payload],
      };
    },
    GET_MARKETING_SOURCES_AND_CATEGORIES: (state, action) => {
      return {
        ...state,
        marketingSources: action.payload[0],
        marketingCategories: action.payload[1],
      };
    },
  },
  INITIAL_STATE,
);

export default MarketingNewsReducer;
